import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { Row, Col, Button, Input, Container, Card, Label, Dropdown, DropdownToggle, DropdownMenu, FormGroup } from "reactstrap";
import ReactTable from 'react-table';
import CreateNewProjectDetails from './Components/CreateNewProjectDetails';
import EditIcon from '../../../../designUtils/OpsDashboard/AccountDetails/EditIcon.svg'
import NewTaskIcon from '../../../../designUtils/OpsDashboard/MyTasks/NewTaskIcon.svg'
import UpdateProjectDetails from './Components/UpdateProjectDetails';
import LoadingOverlay from 'react-loading-overlay';
import Loader from 'react-loaders';
import ClearFilters from '../../../../designUtils/ProjectDashboard/ClearFilters.svg'; 
import ViewProjectAsinList from './Components/ViewProjectAsinList';
import { useLocation } from 'react-router-dom';
import ProjectDashSideBarMainFile from './Scenes/ProjectDashSideBarMainFile';
import FetchAllProjectsListService from '../../../../Service/DashboardServices/ProjectsDashboard/FetchAllProjectsListService';
import UpdateProjectDetailsService from '../../../../Service/DashboardServices/ProjectsDashboard/UpdateProjectDetailsService';
import CustomModal from '../../../Components/Modals/CustomModal';

function ProjectsDashboardMainFile(props) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const directProjectId = searchParams.get('directProject');
  const [directProjectLoading, setDirectProjectLoading] = useState(!!directProjectId);
  const notificationMsg = searchParams.get('notification');
  const [projectDetailsList, setProjectDetailsList] = useState()
  const [isCreateModal, setIsCreateModal] = useState(false);
  const [storeList, setStoreList] = useState()
  const [selectedStore, setSelectedStore] = useState()
  const [accountList, setAccountList] = useState()
  const [selectedAccount, setSelectedAccount] = useState()
  const [ownerList, setOwnerList] = useState()
  const [selectedProjectOwner, setSelectedProjectOwner] = useState()
  const [selectedGraphicDesigner, setSelectedGraphicDesigner] = useState()
  const [statusList, setStatusList] = useState()
  const [selectedStatus, setSelectedStatus] = useState()
  const [pojectHomePage,setProjectHomePage]=useState(true)
  const [selectedProjectData,setSelectedProjectData]=useState('')
  const [searchText, setSearchText] = useState('');
  const [updateProjectOwnerLoading, setUpdateProjectOwnerLoading] = useState(null);
  const [openProjectEditPopup,setOpenProjectEditPopup]=useState(false)
  const [workFlowList, setWorkFlowList] = useState()
  const [brandList, setBrandList] = useState()
  const [projectDetailsForEdit, setProjectDetailsForEdit] = useState('')
  const [updatingProjectOwnerId, setUpdatingProjectOwnerId] = useState(null);
  const [updatingGraphicDesignerId, setUpdatingGraphicDesignerId] = useState(null);
  const [graphicDesignerList,setGraphicDesignerList]=useState()
  const[loading,setLoading]=useState(false)
  const [allAsinList, setAllAsinList] = useState([]);
  const [showAsin, setShowAsin] = useState(false);
  const [projectName, setProjectName] = useState([]);
  const [openDesignerDropdownProjectId, setOpenDesignerDropdownProjectId] = useState(null);
  const [isProjectName, setIsProjectName] = useState(false);
  const [projectPermissions,setProjectPermissions]= useState();
  const [notificationsDetails, setNotificationsDetails] = useState(null);
  
  // State for ASIN Details Modal



  const toggleModal = () => setIsCreateModal(prev => !prev);
  const toggleEditPopup = () => setOpenProjectEditPopup(prev => !prev);
  const toggleViewAsinPopup = () => setShowAsin(prev => !prev);

  
const fetchProjects = async () => {
  try {
    const res = await FetchAllProjectsListService(props.token);
    if (!res) return null;

    // Apply response data
    setProjectDetailsList(res.ProjectDetailsList);
    setStoreList(res.storeDataList);
    setAccountList(res.accountList);
    setOwnerList(res.ownerList);
    setStatusList(res.projectSatusList);
    setWorkFlowList(res.workflowsMaster);
    setBrandList(res.brandsList);
    setGraphicDesignerList(res.graphicDesignerList);
    setProjectPermissions(res.userPermissions);

    return res;
  } catch (error) {
    console.error("Error fetching projects:", error);
    return null;
  }
};

// Direct project loader
const loadProjectDirectly = async (projectId, message) => {
  console.log("Loading project directly for ID:", projectId);
  setDirectProjectLoading(true);

  try {
    const res = await fetchProjects();
    if (!res) return;

    const targetProject = res.ProjectDetailsList.find(
      (project) => project.projectId.toString() === projectId.toString()
    );

    if (targetProject) {
      setSelectedProjectData(targetProject);
      setProjectHomePage(false);

      // Check for tab parameter
      const searchParams = new URLSearchParams(window.location.search);
      const tabParam = searchParams.get('tab');

      if (message) {
        setNotificationsDetails({
          tabs: tabParam === 'assets' ? 2 : 1, // Set to 2 for Project Assets
          details: decodeURIComponent(message),
          action: true,
          searchparams: projectId,
        });
      }

      // Clean URL params
      const url = new URL(window.location);
      url.searchParams.delete("directProject");
      url.searchParams.delete("notification");
      url.searchParams.delete("tab");
      window.history.replaceState({}, document.title, url.pathname);
    } else {
      console.warn(`Project with ID ${projectId} not found`);
      setProjectHomePage(true);
    }
  } finally {
    setDirectProjectLoading(false);
  }
};


useEffect(() => {
  console.log("useEffect triggered with:", {
    directProjectId,
    notificationMsg,
    locationState: location.state,
    token: !!props.token,
  });

  // Priority 1: Direct project access
  if (directProjectId) {
    loadProjectDirectly(directProjectId, notificationMsg);
    return;
  }

  // Priority 2: Notification redirect
  if (location.state && location.state.redirectToProject && location.state && location.state.projectId) {
    setLoading(true);

    fetchProjects()
      .then((res) => {
        if (!res) return;

        const projectId = location.state.projectId;
        const targetProject = res.ProjectDetailsList.find(
          (project) => project.projectId.toString() === projectId.toString()
        );

        if (targetProject) {
          setSelectedProjectData(targetProject);
          setProjectHomePage(false);
          setNotificationsDetails({
            tabs: 1,
            details: location.state.notificationMessage,
            action: true,
            searchparams: projectId,
          });

          // Clean URL params
          window.history.replaceState({}, document.title, location.pathname);
        }
      })
      .finally(() => setLoading(false));
    return;
  }

  // Priority 3: Normal load
  if (!projectDetailsList || projectDetailsList.length === 0) {
    console.log("Normal page load - loading all projects");
    setLoading(true);
    fetchProjects().finally(() => setLoading(false));
  } else {
    console.log("Projects already loaded, skipping API call");
  }
}, [directProjectId, notificationMsg, location.state, props.token]);



  const handlePageRedirection=(data)=>{
        console.log(data);
        setSelectedProjectData(data)
        setProjectHomePage(false)
  }
  const handleEdit = (rowData) => {
    console.log('Edit clicked for:', rowData);
    setProjectDetailsForEdit(rowData)
    setOpenProjectEditPopup(true);
  };
  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };
  const handleBackToProjectList = () => {
    setProjectHomePage(true);
    setNotificationsDetails(null);
    setSelectedProjectData('');
  };

  // step 1: Convert Id to Text/Name
  const selectedAccountName = selectedAccount && accountList? accountList.find(acc => acc.id === parseInt(selectedAccount)).name: null;
  const selectedStoreName = selectedStore && storeList? storeList.find(store => store.id === parseInt(selectedStore)).name: null;
  const selectedStatusText = selectedStatus && statusList? statusList.find(status => status.id === parseInt(selectedStatus)).text: null;
  //  Step 2: Filter projects
  const filteredProjects = projectDetailsList && projectDetailsList.filter(project => {
    const lowerSearch = searchText.toLowerCase();
  
    const matchesSearch =
      (project.projectId && project.projectId.toString().toLowerCase().includes(lowerSearch)) ||
      (project.accountName && project.accountName.toLowerCase().includes(lowerSearch)) ||
      (project.storeName && project.storeName.toLowerCase().includes(lowerSearch)) ||
      (project.asin && project.asin.toLowerCase().includes(lowerSearch)) ||
      (project.projectName && project.projectName.toLowerCase().includes(lowerSearch)) ||
      (project.projectStatus && project.projectStatus.toLowerCase().includes(lowerSearch)) ||
      (project.owner && project.owner.toLowerCase().includes(lowerSearch)) ||
      (String(project.workflow || '').toLowerCase().includes(lowerSearch)) ||
      (project.brand && project.brand.toLowerCase().includes(lowerSearch)) ||
      (project.graphicDesigner && String(project.graphicDesigner).toLowerCase().includes(lowerSearch));
  
    const projectDesignerIds = Array.isArray(project.graphicDesignerId)
      ? project.graphicDesignerId.map(Number)
      : (project.graphicDesignerId ? [Number(project.graphicDesignerId)] : []);

    const matchesDropdownFilters =
      (!selectedAccount || project.accountName === selectedAccountName) &&
      (!selectedStore || project.storeName === selectedStoreName) &&
      (!selectedStatus || project.projectStatus === selectedStatusText) &&
      (!selectedProjectOwner || project.ownerId === parseInt(selectedProjectOwner)) &&
      (!selectedGraphicDesigner || projectDesignerIds.includes(parseInt(selectedGraphicDesigner)))
  
    return matchesSearch && matchesDropdownFilters;
  });
  const handleOwnerChange = (projectId, e) => {
    const updatedOwnerId = e.target.value;
    setUpdatingProjectOwnerId(projectId);
  
    const data = {
      action: 'true',
      projectId: projectId,
      ownerId: updatedOwnerId,
    };
  
    UpdateProjectDetailsService(props.token, data).then((res) => {
      if (res) {
        setProjectDetailsList(res.ProjectDetailsList);
      }
      setUpdatingProjectOwnerId(null);
    });
  };
  
  const handleDesignerCheckboxChange = (projectId, currentIds, designerId) => {
    const id = Number(designerId);
    const current = Array.isArray(currentIds) ? currentIds.map(Number) : (currentIds ? [Number(currentIds)] : []);
    let updated;
    if (current.includes(id)) {
      updated = current.filter(item => item !== id);
    } else {
      updated = current.concat([id]);
    }
    setUpdatingGraphicDesignerId(projectId);

    const data = {
      action: 'true',
      projectId: projectId,
      graphicDesignerId: updated,
    };

    UpdateProjectDetailsService(props.token, data).then((res) => {
      if (res) {
        setProjectDetailsList(res.ProjectDetailsList);
      }
      setUpdatingGraphicDesignerId(null);
    });
  };
 // Simplified function to show ASIN details modal
 const showAsinList = (asinlist, projectData) => {
  const asinArray = asinlist.split(',').map(asin => asin.trim());
  setAllAsinList(asinArray);
  setProjectDetailsForEdit(projectData);
  setShowAsin(true);
};
  const showProjectName = (projectName) => {
    setProjectName(projectName)
    setIsProjectName(true)
  }

  const columns = [
    {
      Header: "ID",
      accessor: "projectId",
      width: 50,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className=" m-0 cursor-pointer" onClick={()=>handlePageRedirection(cellInfo.original)}>{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "Project Name",
      accessor: "projectName",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p title={cellInfo.value} className="m-0 comment-paragraph" style={{ color: "#3D85C6", cursor: "pointer" }}  onClick={() => showProjectName(cellInfo.value)}>{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "Account Name",
      accessor: "accountName",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p title={cellInfo.value} className="m-0 comment-paragraph">{cellInfo.value}</p>
        </div>
      )
    },
    {
      Header: "Store Name",
      accessor: "storeName",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p title={cellInfo.value} className="m-0 comment-paragraph">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "Workflow",
      accessor: "workflow",
      Cell: (cellInfo) => {
        const workflowLabel = Array.isArray(cellInfo.value)
          ? cellInfo.value.map(function (w) {
              return (w && typeof w === 'object') ? (w.name || '') : w;
            }).filter(Boolean).join(', ')
          : (cellInfo.value && typeof cellInfo.value === 'object'
              ? (cellInfo.value.name || '')
              : (cellInfo.value || ''));
        return (
          <div className="d-flex justify-content-center w-75">
            <p
              title={workflowLabel}
              className="m-0 comment-paragraph"
            >
              {workflowLabel}
            </p>
          </div>
        );
      },
    },
    {
      Header: "Brand",
      accessor: "brand",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-75">
          <p title={cellInfo.value} className="m-0 comment-paragraph">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "ASIN List",
      accessor: "asin",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-75">
          <p title={cellInfo.value} className="m-0 comment-paragraph" style={{ color: "#3D85C6", cursor: "pointer" }}  onClick={() => showAsinList(cellInfo.value, cellInfo.original)}>{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "Start Date",
      accessor: "startDate",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className="m-0">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "Due Date",
      accessor: "dueDate",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className="m-0">{cellInfo.value}</p>
        </div>
      ),
    },
   
    // {
    //   Header: "End Date",
    //   accessor: "endDate",
    //   Cell: (cellInfo) => (
    //     <div className="d-flex justify-content-center w-100">
    //       <p className="m-0">{cellInfo.value}</p>
    //     </div>
    //   ),
    // },
    {
      Header: "Status",
      accessor: "projectStatus",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className="m-0">{cellInfo.value}</p>
        </div>
      ),
    },
    ...(projectPermissions && projectPermissions.ProjectDashboard_CreateUpdateProject // condition for graphics designer 
      ? [
          {
            Header: "Project Owner",
            accessor: "owner",
            Cell: (cellInfo) => {
              const currentOwnerId = cellInfo.original.ownerId;
              const isUpdating =
                updatingProjectOwnerId === cellInfo.original.projectId;
              const currentOwner = Array.isArray(ownerList)
                ? ownerList.find((owner) => owner.employeeId === currentOwnerId)
                : null;
    
              return (
                <div className="d-flex justify-content-center w-100 align-items-center">
                  {isUpdating ? (
                    <p className="mb-0" style={{ color: "#81e94b" }}>
                      Updating...
                    </p>
                  ) : (
                    <select
                      style={{
                        minWidth: "90px",
                        maxWidth: "100%",
                        whiteSpace: "nowrap",
                        fontSize: "14px",
                      }}
                      name="ownerId"
                      className="form-control create-new-project-width"
                      value={currentOwnerId || ""}
                      onChange={(e) =>
                        handleOwnerChange(cellInfo.original.projectId, e)
                      }
                    >
                      <option disabled value="">
                        Select Project Owner
                      </option>
                      {ownerList &&
                        ownerList.map((Owner) => (
                          <option key={Owner.employeeId} value={Owner.employeeId}>
                            {Owner.employeeName}
                          </option>
                        ))}
                    </select>
                  )}
                </div>
              );
            },
          },
        ]
      : []),
      ...(projectPermissions && projectPermissions.ProjectDashboard_CreateUpdateProject // condition for graphics designer 
        ? [
            {
      Header: "Graphic Designer",
      accessor: "graphicDesigner",
      Cell: (cellInfo) => {
        const currentDesignerIds = Array.isArray(cellInfo.original.graphicDesignerId)
          ? cellInfo.original.graphicDesignerId.map(Number)
          : (cellInfo.original.graphicDesignerId ? [Number(cellInfo.original.graphicDesignerId)] : []);
        const isUpdating = updatingGraphicDesignerId === cellInfo.original.projectId;
        const selectedNames = (graphicDesignerList || [])
          .filter(d => currentDesignerIds.includes(Number(d.id)))
          .map(d => d.name)
          .join(', ') || 'Select Graphic Designer';
        const isOpen = openDesignerDropdownProjectId === cellInfo.original.projectId;

        return (
          <div className="d-flex justify-content-center w-100 align-items-center">
            {isUpdating ? (
              <p className="mb-0" style={{ color: "#81e94b" }}>
                Updating...
              </p>
            ) : (
              <Dropdown
                isOpen={isOpen}
                toggle={() => setOpenDesignerDropdownProjectId(isOpen ? null : cellInfo.original.projectId)}
                style={{ minWidth: '120px', maxWidth: '100%' }}
              >
                <DropdownToggle
                  caret
                  className="form-control d-flex justify-content-between align-items-center"
                  style={{
                    backgroundColor: 'white',
                    color: '#495057',
                    textAlign: 'left',
                    fontSize: '14px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '85%' }}>
                    {selectedNames}
                  </span>
                </DropdownToggle>
                <DropdownMenu style={{ maxHeight: '200px', overflowY: 'auto', padding: '8px', minWidth: '220px' }}>
                  {graphicDesignerList && graphicDesignerList.map((designer) => (
                    <FormGroup check key={designer.id} className="m-2">
                      <Label check style={{ cursor: 'pointer', width: '100%' }}>
                        <Input
                          type="checkbox"
                          checked={currentDesignerIds.includes(Number(designer.id))}
                          onChange={() => handleDesignerCheckboxChange(
                            cellInfo.original.projectId,
                            currentDesignerIds,
                            designer.id
                          )}
                        />
                        {' '}{designer.name}
                      </Label>
                    </FormGroup>
                  ))}
                </DropdownMenu>
              </Dropdown>
            )}
          </div>
        );
      },
    },  
  ]
  : []),  
   ...( projectPermissions && projectPermissions.ProjectDashboard_CreateUpdateProject   ? [{
      // condition for graphics designer access level 5
      Header: "Edit",
      accessor: "projectId",
      width: 50,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <img 
            src={EditIcon} 
            alt="Edit" 
            style={{ width: "16px", height: "16px", cursor: "pointer" }} 
            onClick={() => handleEdit(cellInfo.original)}
          />
        </div>
      ),
    }] : []),  
  ];
  const handleStoreChange = (e) => {
    const value = e.target.value;
    setSelectedStore(value);
  };
  const handleAccountChange = (e) => {
    const value = e.target.value;
    setSelectedAccount(value);
    setSelectedStore('');
  };
  const handleProjectOwnerChange = (e) => {
    const value = e.target.value;
    setSelectedProjectOwner(value);
  };
  const handleGraphicDesignerChange = (e) => {
    const value = e.target.value;
    setSelectedGraphicDesigner(value);
  };
  const handleStatusChange = (e) => {
    const value = e.target.value;
    setSelectedStatus(value);
  };
  const handleRefreshPage=()=>{
    setSelectedStatus('')
    setSelectedAccount('')
    setSelectedGraphicDesigner('')
    setSelectedProjectOwner('')
    setSelectedStore('')
    setSelectedStore('')
    setSearchText('')
  }
  if (directProjectLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
        <LoadingOverlay
          active={true}
          styles={{
            overlay: (base) => ({
              ...base,
              background: '#f1f4f6',
              opacity: 1,
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              zIndex: 9999
            }),
            content: (base) => ({
              ...base,
              color: '#000',
            }),
          }}
          spinner={<Loader active type="ball-pulse" />}
          text='Loading project details...'
        >
          <div style={{ height: '100vh', width: '100vw' }}></div>
        </LoadingOverlay>
      </div>
    );
  }
  return (
    <>
     {/* <Container style={{marginTop:'50px'}} className='justify-content-between'> */}
     {pojectHomePage?
      <>
       <Card className='card-of-problemarea p-4 mt-5 ml-4 mr-4'>
          <Row className="align-items-center justify-content-between">
            <Col md={6}>
              <h4 style={{ color: 'black' }}><b>Project List</b></h4>
            </Col>
            <Col md={6} className="d-flex justify-content-end mt-3">
              <div>
              <Input type='text'
                  placeholder='Search Text'
                  value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
             { projectPermissions && projectPermissions.ProjectDashboard_CreateUpdateProject ?<div className='ml-4'>
                <Button
                  className="btn-background-color "
                  onClick={toggleModal}
                disabled={loading}
                >
                  New Project
                  <img className='ml-2 mb-1' src={NewTaskIcon} style={{ height: '18px' }} />
                </Button>
              </div>:''}
            </Col>
          </Row>

          <Row className="mt-3">
          <Col md={2}>
              <select
                className="form-control"
                onChange={handleAccountChange}
                value={selectedAccount || ""}
                style={{
                  color: !selectedAccount ? "#6c757d" : "#050505",
                }}
              >
                        <option value="" >--Select Account--</option>
                        {accountList && accountList.map((account) => (
                          <option key={account.id} value={account.id}>
                            {account.name}
                          </option>
                        ))}
                      </select>
            </Col>
            <Col md={2}>
              <select
                className="form-control"
                onChange={handleStoreChange}
                value={selectedStore || ""}
                style={{
                  color: !selectedStore ? "#6c757d" : "#050505",
                }}
              >
                <option value="">--Select Store--</option>
                {storeList && storeList
                .filter(store => 
                  !selectedAccount || store.account_details === parseInt(selectedAccount)
                )
                .map((store) => (
                  <option key={store.id} value={store.id}>
                    {store.name}
                  </option>
                ))}
              </select>
            </Col>
            <Col md={2}>
              <select
                className="form-control"
                onChange={handleStatusChange}
                value={selectedStatus || ""}
                style={{
                  color: !selectedStatus ? "#6c757d" : "#050505",
                }}
              >
                <option value="">--Select Status--</option>
                {statusList && statusList.map((status) => (
                  <option key={status.id} value={status.id}>
                    {status.text}
                  </option>
                ))}
              </select>
            </Col>
            { projectPermissions && projectPermissions.ProjectDashboard_CreateUpdateProject  ? ( // condition for graphics designer access level 5
            <>
            <Col md={2}>
              <select
                className="form-control"
                onChange={handleProjectOwnerChange}
                value={selectedProjectOwner || ""}
                style={{
                  color: !selectedProjectOwner ? "#6c757d" : "#050505",
                }}
              >
                <option value="">--Select Project Owner--</option>
                {ownerList && ownerList.map((owner) => (
                  <option key={owner.employeeId} value={owner.employeeId}>
                    {owner.employeeName}
                  </option>
                ))}
              </select>
            </Col>
            <Col md={3}>
              <select
                className="form-control"
                onChange={handleGraphicDesignerChange}
                value={selectedGraphicDesigner || ""}
                style={{
                  color: !selectedGraphicDesigner ? "#6c757d" : "#050505",
                }}
              >
                <option value="">--Select Graphic Designer--</option>
                {graphicDesignerList && graphicDesignerList.map((designer) => (
                  <option key={designer.id} value={designer.id}>
                    {designer.name}
                  </option>
                ))}
              </select>
            </Col>
            </>
            ):<Col md={5}></Col>}
            <Col md={1} className="d-flex justify-content-end align-items-center ms-auto mt-1">
                <img
                  src={ClearFilters}
                  onClick={() => handleRefreshPage()}
                  style={{ cursor: 'pointer' }}
                  alt="Clear Filters"
                  title="Clear Filters"
                />
              </Col>
          </Row>
        </Card>
        <Card className='card-of-problemarea mt-4 p-4'>
        <LoadingOverlay
          active={loading}
          styles={{
            overlay: (base) => ({
              ...base,
              background: '#f1f4f6',
              opacity: 1,
            }),
            content: (base) => ({
              ...base,
              color: '#000',
            }),
          }}
          spinner={<Loader active type="ball-pulse" />}
          text='Loading your project list...'
      >
          <Row>
            <Col>
              <ReactTable
                data={filteredProjects}
                columns={columns}
                className="-fixed -highlight -striped mt-2"
                getTheadProps={() => {
                  return {
                    style: {
                      overflowY: "hidden",
                      background: "#B1FA63",
                      color: "#243837",
                    },
                  };
                }}
                defaultPageSize={10}
                noDataText={"No Data Found."}
              />

            </Col>
          </Row>
          </LoadingOverlay>
        </Card>
      </>:
      <ProjectDashSideBarMainFile
      projectPermissions={projectPermissions}
      setProjectDetailsForEdit={setProjectDetailsForEdit}
      projectDetailsForEdit={projectDetailsForEdit}
      selectedProjectData={selectedProjectData}
      onBackHeader={handleBackToProjectList}
      isMyworksScreen={true}
      notificationsDetails={notificationsDetails}
      setNotificationsDetails={setNotificationsDetails}
      />}
       {/* </Container> */}
       <CustomModal
            header={"Create New Project"}
            isOpen={isCreateModal}
            toggle={toggleModal}
            size={"lg"}
            className='curve-popup'
          >
            <CreateNewProjectDetails
              storeList={storeList}
              projectPermissions={projectPermissions}
              graphicDesignerList={graphicDesignerList}
              accountList={accountList}
              ownerList={ownerList}
              projectDetailsList={projectDetailsList}
              workFlowList={workFlowList}
              brandList={brandList}
              setIsCreateModal={setIsCreateModal}
              setProjectDetailsList={setProjectDetailsList} />
          </CustomModal>
          {/* <CustomModal
        header={"ASIN List"}
        isOpen={showAsin}
        toggle={() => setShowAsin(!showAsin)}
        size={"md"}
        className='curve-popup'
        footer={
          <>
            <Button
              color={"link"}
              onClick={() => setShowAsin(!showAsin)}
            >
              Cancel
            </Button>
          </>
        }
      >
        <Label>
          <ul>
            {allAsinList && allAsinList.map((asin, index) => (
              <li key={index}>{asin}</li>
            ))}
          </ul>
        </Label>
      </CustomModal> */}


        {/* View ASIN List Modal */}
        <CustomModal
            header={
              <span>
              <b>{ projectDetailsForEdit.projectName } </b> : ASIN List
            </span>
            }
            isOpen={showAsin}
            toggle={toggleViewAsinPopup}
            size={"lg"}
            className='curve-popup my-task-custom-module'
          >
            <ViewProjectAsinList
              projectData={projectDetailsForEdit}
              asinList={allAsinList}
              projectPermissions={projectPermissions}
            />
      </CustomModal>

      <CustomModal
        header={"Project Name"}
        isOpen={isProjectName}
        toggle={() => setIsProjectName(!isProjectName)}
        size={"md"}
        className='curve-popup'
        footer={
          <>
            <Button
              color={"link"}
              onClick={() => setIsProjectName(!isProjectName)}
            >
              Cancel
            </Button>
          </>
        }
      >
        <Label>
          <p>{projectName}</p>
        </Label>
      </CustomModal>
          <CustomModal
            header={"Edit Project"}
            isOpen={openProjectEditPopup}
            toggle={toggleEditPopup}
            size={"lg"}
            className='curve-popup'
          >
            <UpdateProjectDetails
              selectedProjectData={selectedProjectData}
              storeList={storeList}
              accountList={accountList}
              graphicDesignerList={graphicDesignerList}
              // asinList={asinList}
              brandList={brandList}
              ownerList={ownerList}
              projectDetailsForEdit={projectDetailsForEdit}
              setOpenProjectEditPopup={setOpenProjectEditPopup}
              setProjectDetailsList={setProjectDetailsList}
              projectDetailsList={projectDetailsList}
            />
          </CustomModal>
     
    </>
  )

}
const mapStateToProps = state => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
  }
}

export default connect(mapStateToProps)(ProjectsDashboardMainFile);
